import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ChatMessageListItemComponent } from './chat-message-list-item/chat-message-list-item.component';

@NgModule({
  imports: [CommonModule, MatProgressSpinnerModule, MatButtonModule, FormsModule],
  declarations: [ChatMessageListItemComponent],
  exports: [ChatMessageListItemComponent]
})
export class ChatModule {}
